<template>
  <v-autocomplete
    v-if="opportunityId"
    label="Phase"
    v-model="model"
    @input="handleInput"
    :items="phases"
    item-text="name"
    item-value="id"
    :loading="isLoading"
    :required="required"
    :rules="rules || []"
    hide-no-data
    clearable
  />
</template>

<script>
export default {
  name: 'OpportunityPhaseSelect',
  props: {
    value: { required: true },
    opportunityId: { type: Number, required: true },
    required: { type: Boolean, default: () => false },
    rules: { type: Array, default: () => [] },
  },

  data() {
    return {
      model: this.normalizedValue(this.value),
      opportunityLocal: null,
      loading: false,
    }
  },

  computed: {
    isLoading() {
      return this.loading
    },

    phases() {
      if (this.opportunityLocal && Array.isArray(this.opportunityLocal.phases)) {
        return this.opportunityLocal.phases.map(p => ({ id: p.id, name: p.name }))
      }
      return []
    },
  },

  watch: {
    value(newVal) {
      this.model = this.normalizedValue(newVal)
    },
    opportunityId: {
      immediate: true,
      handler(id) {
        if (id) this.loadOpportunity(id)
      },
    },
  },

  methods: {
    normalizedValue(val) {
      if (val && typeof val === 'object') return val.id
      return val || null
    },
    async loadOpportunity(id) {
      this.loading = true
      this.opportunityLocal = null
      try {
        const { data } = await this.$http.get(`admin/opportunities/${id}`)
        this.opportunityLocal = data
      } finally {
        this.loading = false
      }
    },
    handleInput(selected) {
      const id = this.normalizedValue(selected)
      this.$emit('input', id)
    },
  },
}
</script>

